/* eslint-disable no-param-reassign */
import PropTypes from "prop-types";
import { extractData } from "../utils";

const MenuList = ({ children, ...componentProps }) => {
  const Component = componentProps.selectProps?.custom?.MenuList;

  if (!Component) {
    return null;
  }

  return (
    <Component componentProps={componentProps} data={extractData(componentProps)}>
      {children}
    </Component>
  );
};

MenuList.propTypes = {
  selectProps: PropTypes.shape({
    custom: PropTypes.shape({
      MenuList: PropTypes.func,
    }),
  }),
  children: PropTypes.node,
};

MenuList.defaultProps = {
  selectProps: {
    custom: {
      MenuList: null,
    },
  },
  children: null,
};

export default MenuList;
